/**
 * @returns {boolean}
 */
export function isDev() {
  const {NODE_ENV} = process.env;

  return NODE_ENV === 'development';
}

export function formatCurrency(value) {
  return value.toString().replace('.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
}

export function emailIsValid(email) {
  if (!email) {
    return false
  }

  return !!email.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i)
}